import { css } from "styled-components";
export const keyboardFocus = css `
  &:focus-visible {
    box-shadow:
      0 0 0 2px ${({ theme }) => theme.systemColors.white},
      0 0 0 4px ${({ theme }) => theme.systemColors.blue600};
  }
`;
